<button type="button" class="report-download-button" (click)="openDialog()" title="Click to download table data">
	<svg [lucideIcon]="icon()"></svg>
	<span>Export</span>
</button>